__turbopack_context__.v({
  "activePanelDoc": "PageInputBox-module__4jUnGG__activePanelDoc",
  "chipActionsBar": "PageInputBox-module__4jUnGG__chipActionsBar",
  "chipDraggable": "PageInputBox-module__4jUnGG__chipDraggable",
  "chipList": "PageInputBox-module__4jUnGG__chipList",
  "chipPillWrap": "PageInputBox-module__4jUnGG__chipPillWrap",
  "chipRowSelected": "PageInputBox-module__4jUnGG__chipRowSelected",
  "chipSelectionOverlay": "PageInputBox-module__4jUnGG__chipSelectionOverlay",
  "emptyState": "PageInputBox-module__4jUnGG__emptyState",
  "panelDoc": "PageInputBox-module__4jUnGG__panelDoc",
});
